function checkForParams(){
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  return params.variant
}

function isBrowserSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

// Runs `done` after Shopify's hCaptcha has attached a token to `form`.
// Required for forms we submit programmatically -- native form.submit() does not
// fire submit listeners, so it would otherwise bypass Shopify's captcha hook.
// Falls straight through when spam protection is off, or on `shopify theme dev`
// where the captcha bootstrap isn't served.
//
// If protect() never invokes its callback (user dismissed the challenge, hCaptcha
// asset blocked) `onTimeout` runs instead after 15s. It deliberately does NOT fall
// back to `done` -- submitting without a token earns a 400, which is the exact
// failure this helper exists to avoid. Callers should reset their UI and surface
// an error from `onTimeout`.
function fbCaptchaProtect(form, done, onTimeout) {
  var settled = false;
  var finish = function (fn) {
    if (settled) return;
    settled = true;
    fn();
  };

  if (window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === 'function') {
    var timer = setTimeout(function () {
      finish(onTimeout || function () {});
    }, 15000);
    Shopify.captcha.protect(form, function () {
      clearTimeout(timer);
      finish(done);
    });
  } else {
    finish(done);
  }
}

